import React from "react";
import { MobilePageHeader } from "../components/layout/MobileAppChrome";
import "../styles/pages/ContactPage.css";

const ContactPage: React.FC = () => {
  return (
    <section className="shell section page-section contact-page">
      <div className="contact-page__mobile-header">
        <MobilePageHeader title="Contact & support" />
      </div>
      <div className="page-header">
        <span className="eyebrow">Contact & support</span>
        <h1>Talk to product and order support</h1>
        <p>
          Reach us for product recommendations, order assistance, or post-purchase help.
        </p>
      </div>

      <div className="contact-layout">
        <aside className="contact-stack">
          <div className="store-card support-card">
            <h2>Support hours</h2>
            <div className="contact-info-list">
              <div className="contact-info-item">
                <span>Available</span>
                <strong>Mon-Sat · 9:00 AM to 8:00 PM</strong>
              </div>
              <div className="contact-info-item">
                <span>Email</span>
                <strong>
                  <a href="mailto:support@Eldoo.in">support@Eldoo.in</a>
                </strong>
              </div>
              <div className="contact-info-item">
                <span>Phone</span>
                <strong>
                  <a href="tel:+919347023242">+91 93470 23242</a>
                </strong>
              </div>
            </div>
          </div>
          <a
            className="store-card whatsapp-card"
            href="https://wa.me/919347023242?text=Hi%20Eldoo%2C%20I%20need%20help%20with%20a%20product."
            target="_blank"
            rel="noreferrer"
          >
            <span>WhatsApp support</span>
            <strong>Start a quick chat with our team</strong>
          </a>
        </aside>
      </div>
    </section>
  );
};

export default ContactPage;
